let timer;
export const loader = {
    namespaced: true,
    state: {
        loading: false,
        requestsPending: 0,
    },
    actions: {
        show({ commit }) {
            commit("show");
        },
        hide({ commit }) {
            commit("hide");
        },
        pending({ commit }) {
            commit("pending");
        },
        done({ commit }) {
            commit("done");
        },
        reset({ commit }) {
            commit("reset");
        }
    },
    mutations: {
        debounce(){
            clearTimeout(timer);
            timer = setTimeout(() => {
                console.log('timer'); 
                this.commit("loader/reset");
            }, 30000);
        },
        show(state) {
            state.loading = true;
            this.commit("loader/debounce");
        },
        hide(state) {
            state.loading = false;
        },
        pending(state) {
            document.documentElement.style.overflow = 'hidden'
            this.commit("loader/show");
            state.requestsPending++;
        },
        done(state) {
            console.log("done", state.requestsPending);
            document.documentElement.style.overflow = 'auto'
            this.commit("loader/hide");
        },
        reset(state) {
            state.requestsPending = 0
            this.commit("loader/hide");
        }
    }
};